import { useEffect, useState } from "react";
import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// sessionStorage holds ONLY anonymous values: a "1" flag (visit already counted this tab session)
// and a random UUID used as heartbeat id. No PII, tokens or credentials are stored.
const VISIT_TRACKED_KEY = "masterx_visit_tracked";
const SESSION_ID_KEY = "masterx_session_id";

const randomId = () =>
  (crypto?.randomUUID && crypto.randomUUID()) || `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export function getSessionId() {
  let sid = sessionStorage.getItem(SESSION_ID_KEY);
  if (!sid) {
    sid = randomId();
    sessionStorage.setItem(SESSION_ID_KEY, sid);
  }
  return sid;
}

const isNumber = (v) => typeof v === "number";

// Counts the visit once per tab session, otherwise just reads the total.
async function fetchVisitTotal() {
  const alreadyTracked = sessionStorage.getItem(VISIT_TRACKED_KEY);
  const res = alreadyTracked
    ? await axios.get(`${API}/visits/count`)
    : await axios.post(`${API}/visits/track`);
  if (!alreadyTracked && isNumber(res.data?.count)) sessionStorage.setItem(VISIT_TRACKED_KEY, "1");
  return res.data?.count;
}

export function useVisitTotal() {
  const [count, setCount] = useState(null);

  useEffect(() => {
    let cancelled = false;
    fetchVisitTotal()
      .then((total) => {
        if (!cancelled && isNumber(total)) setCount(total);
      })
      .catch((e) => console.warn("[VisitorCounter] total indisponível:", e?.message));
    return () => {
      cancelled = true;
    };
  }, []);

  return count;
}
